import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import createAttachments from 'owa-calendar-compose-form-store/lib/actions/createAttachments';
import getEventClientItemId from 'owa-calendar-compose-form-store/lib/utils/getEventClientItemId';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { orchestrator } from 'satcheljs';
import { updateCalendarEvents } from 'owa-calendar-compose-form-actions';
import {
    getPendingInlineImages,
    clearPendingInlineImages,
} from 'owa-calendar-compose-form-store/lib/utils/pendingInlineImages';

export default orchestrator(updateCalendarEvents, actionMessage => {
    const event: CalendarEvent = actionMessage.event;
    const pendingInlineImages = getPendingInlineImages();
    const composeViewState = getFullComposeViewState();
    if (
        composeViewState &&
        pendingInlineImages.length > 0 &&
        event &&
        event.ItemId &&
        event.ItemId.Id
    ) {
        clearPendingInlineImages();
        createAttachments(composeViewState, getEventClientItemId(), pendingInlineImages, {
            isInline: true,
            isHiddenInline: false,
            shouldShare: false,
        });
    }
});
